module.exports = __webpack_public_path__ + "media/images/icons/flags/lang-nl-51c550b1576d01f270c9f7318d0e63a1.svg";